import { injectable } from "inversify";
import React from "react";
import { WizardConfig, WizardStep } from "../../models/wizard";
import { WizardService } from "../../services";
import { ServiceBase } from "../../services/ServiceBase";
import { Wizard } from "../components/Wizard";
import { ReactDOMProxy } from "../ReactDOMProxy";

/**
 * MUI stepper service, used to fulfill wizard service requirements and provide wizard like functionality.
 */
@injectable()
export class MaterialStepperService extends ServiceBase implements WizardService {

	/**
	 * @inheritdoc
	 */
	applyAll(target: Element): void {

		target.querySelectorAll("[data-wizard]").forEach(this.render);
	}

	/**
	 * @inheritdoc
	 */
    render(targetElement: Element) {

		// get step element using attribute selector
        const stepElements = targetElement.querySelectorAll("[data-step]");

		// get active step element using attribute selector
        const activeStepElement = targetElement.querySelector("[data-active-step]") as HTMLInputElement;

		// create wizard configuration
        const wizardConfig = new WizardConfig(targetElement, MaterialStepperService.getSteps(stepElements), activeStepElement);

		// output the wizard component
        ReactDOMProxy.renderStyled(
            <Wizard config={wizardConfig} />,
            targetElement
        );
    }

	/**
	 * Gets the wizard steps for an array of step elements.
	 * @param stepElements Node list of elements.
	 * @returns Array of WizardStep.
	 */
    private static getSteps(stepElements: NodeListOf<Element>): Array<WizardStep> {

        const steps = new Array<WizardStep>();

        stepElements.forEach((stepElement, index) => {

            const titleElement = stepElement.querySelector("[data-step-title]");
            const title = titleElement?.innerHTML || "";

            steps.push(new WizardStep(stepElement, title, index));

            if (titleElement) {

                titleElement.parentNode?.removeChild(titleElement);
            }
        });

        return steps;
    }

}